import { render } from "./IntroTab.vue?vue&type=template&id=04a27d18"
import script from "./IntroTab.vue?vue&type=script&lang=js"
export * from "./IntroTab.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./IntroTab.vue?vue&type=style&index=0&id=04a27d18&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__